import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { getParsedValue } from "./utils";
import LiveChart from "./LiveChart";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 5px 15px 0px 15px;
`;

const getValue = (item, type) => {
  if (item === null) {
    return null;
  }
  const { time } = item;
  return Object.entries(item).reduce(
    (acc, [key, value]) => {
      if (key !== "time") {
        const linkKey = `${type}link`;
        acc[key] = {
          [linkKey]: getParsedValue(value[linkKey]),
        };
      }

      return acc;
    },
    { time }
  );
};

const ClusterThroughput = ({
  maxValue,
  resetSignal,
  item,
  fields,
  map,
  timeWindow,
  test,
}) => {
  const [mouseEvent, setMouseEvent] = useState();
  const [filterFields, setFilterFields] = useState(new Set());

  useEffect(() => {
    if (fields.length > 0) {
      setFilterFields(new Set(fields.map((field) => field.name)));
    }
  }, [fields.length]);

  const handleMouseEvent = (event) => {
    if (event) {
      setMouseEvent({ ...event });
    } else {
      setMouseEvent(null);
    }
  };

  return (
    <Wrapper className="card">
      {!map ? null : (
        <div className="row clearfix">
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <LiveChart
              title="Downlink Throughput"
              key="downlink-charts"
              fields={fields}
              fieldsMap={map}
              value={getValue(item, "down")}
              type="down"
              onMouseEvent={handleMouseEvent}
              mouseEvent={mouseEvent}
              timeWindow={timeWindow < 100 ? timeWindow : timeWindow / 100}
              filterFields={filterFields}
              onFilterFieldsChange={(filter) => setFilterFields(filter)}
              fixedYRange={maxValue.downlink === 0 ? [0, 100] : undefined}
              resetSignal={resetSignal}
              test={test}
            />
          </div>
          {!test && (
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <LiveChart
                title="Uplink Throughput"
                key="uplink-charts"
                fields={fields}
                fieldsMap={map}
                value={getValue(item, "up")}
                type="up"
                onMouseEvent={handleMouseEvent}
                mouseEvent={mouseEvent}
                timeWindow={timeWindow < 100 ? timeWindow : timeWindow / 100}
                filterFields={filterFields}
                onFilterFieldsChange={(filter) => setFilterFields(filter)}
                fixedYRange={maxValue.uplink === 0 ? [0, 100] : undefined}
                resetSignal={resetSignal}
              />
            </div>
          )}
        </div>
      )}
    </Wrapper>
  );
};

export default ClusterThroughput;
